/**
 * Appointment Cancelled - Automated Messages Settings
 * Configure messages sent when an appointment is canceled (by staff or by the client)
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { AppointmentCancelledTimeline } from './automated-messages/components/appointment-cancelled-timeline'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute(
  '/_auth/$orgId/settings/automated-messages/appointment-cancelled',
)({
  component: AppointmentCancelledPage,
})

function AppointmentCancelledPage() {
  const { orgId } = useParams({
    from: '/_auth/$orgId/settings/automated-messages/appointment-cancelled',
  })

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Appointment Canceled', 'Automated Messages')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="appointment-cancelled">
        <SettingsPageHeader
          title="Appointment Canceled"
          description="Configure which automated messages are sent when appointments get canceled."
        />

        <div className="max-w-3xl">
          <AppointmentCancelledTimeline />
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
